export enum ConfirmDialogStatus {
  Confirmed,
  Canceled,
  Closed
}
